const doc = [({"en":({"js":({"admin":({"competitions":({"surveys":({"add_surveys":"Add surveys...", "the_survey_was_added":"The survey was added"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;